import React from 'react'
import Card from './card'
import { motion } from 'framer-motion'
import api from '../icons/api.svg'
import repair from '../icons/repair.svg'
import computer from '../icons/computer.svg'
import ux from '../icons/ux.svg'
import puzzle from '../icons/puzzle.svg'
import wordpress from '../icons/wordpress.svg'
import sass from '../icons/sass.svg'
import amazon from '../icons/amazon.svg'
import react from '../icons/react.svg'
import google_analytics_icon from '../icons/google_analytics_icon.svg'
import jira from '../icons/jira.svg'
import github from '../icons/github.svg'

const About = () => {
	const aboutVariants = {
		initial: {
			opacity: 0,
		},
		visible: {
			opacity: 1,
			transition: {
				delay: 0.1,
				duration: 0.7,
			},
		},
		exit: {
			opacity: 0,
			transition: {
				ease: 'easeInOut',
			},
		},
	}

	return (
		<motion.div
			className="content_section"
			variants={aboutVariants}
			initial="initial"
			animate="visible"
			exit="exit"
		>
			<div className="description">
				<p>
					Self motivated React JS developer with 4+ years of experience
					worked on multiple projects. Knowledgeable of all the
					development cycle stages and have a good command of coding
					languages. I have much experience in teamwork and excellent
					problem-solving skills.
				</p>
			</div>
			<div className="data_section">
				<div className="container">
					<p className="sub_heading">{'What I Know'}</p>
					<div className="row">
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={computer}
								title="Frontend Development"
								body={[
									'Extensive experience in developing web pages using ',
									<strong>
										{
											'HTML, CSS3, SASS, LESS, Bootstrap, JQuery, JSON, JavaScript, React JS, Redux, GraphQL,  Material UI Framework'
										}
									</strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={amazon}
								title="Amazon Web Services (AWS) "
								body={[
									'Knowledge of configuration for creating User pool and Client App Id,  Authentication with email, Social(Facebook and Google), writing ',
									<strong>
										{
											'Lambda Function, IAM, Key Management Services (KMS), Cloudwatch'
										}
									</strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={sass}
								title="CSS Framework "
								body={[
									'Good experience on customizing CSS frameworks like Bootstrap and Foundation using CSS pre-processors ',
									<strong>{'LESS or SASS'}</strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={repair}
								title="AEM React Integration(AEM UI Developer) "
								body={[
									'SPA implementation with AEM 6.5 with ',
									<strong> {'React Js'} </strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={api}
								title="API Development "
								body={[
									'Basic Knowledge to Develop robust REST API using ',
									<strong> {'Node Js'}</strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={ux}
								title="Webpack Configurations "
								body={[
									'minimalistic user interface designer using ',
									<strong>{'Webpack'}</strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={react}
								title="React JS framework "
								body={[
									'Expertise in React JS framework to develop the SPA.',
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={google_analytics_icon}
								title="Google Analytics "
								body={[
									'Implementated Google Analytics in ',
									<strong>{'React Project'}</strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={puzzle}
								title="Graphics Designer"
								body={[
									' Design in free time using ',
									<strong>{'Illustrator'}</strong>,
									'(creating Banner and logo)',
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={puzzle}
								title="Social Login (Facebook and Google) "
								body={[
									'Integration and configuration with AWS and Application with Developers Account ',
									<strong>{'Facebook and Google'}</strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={github}
								title="Versioning Tools "
								body={[
									'Extensively used ',
									<strong>{'GIT'}</strong>,
									' for version controlling ad regularly pushed the code to ',
									<strong>{'Github and Bitbucket'}</strong>,
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={jira}
								title="Agile Methodology JIRA and Confluence "
								body={[
									'Used ',
									<strong>{'JIRA and Confluence'}</strong>,
									' as the bug tracking system to track and maintain the history of bugs/issues on everyday basis. ',
								]}
							/>
						</div>
						<div className="col-sm-12 col-lg-6">
							<Card
								icon={wordpress}
								title="Wordpress Development "
								body={[
									'Develops Static beautiful websites, blogs, Website using ',
									<strong>{'Wordpress'}</strong>,
									' templetes',
								]}
							/>
						</div>
					</div>
				</div>
			</div>
		</motion.div>
	)
}

export default About
